import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addIVRExtension, updateIVRExtension } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function IVRExtensionCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    extension: state?.extension || "",
    description: state?.description || "",
    status: state?.status || true,
  });
  const [errors, setErrors] = useState({
    extension: "",
    description: "",
    status: "",
  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);



  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.extension)) {
      newErrors.extension = "Please Enter Extension";
      isValid = false;
    } else {
      newErrors.extension = "";
    }



    if (input.description === "") {
      newErrors.description = "Please Enter Description";
      isValid = false;
    } else {
      newErrors.description = "";
    }

    

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          extension: input.extension,
          description: input.description,
          status: input.status,
        };
        updateIVRExtension(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/IVRExtension/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          extension: input.extension,
          description: input.description,
          status: true
        };
        addIVRExtension(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/IVRExtension/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/IVRExtension/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> IVR Extension {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Extension
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="extension"
                        name="extension"
                        value={input.extension}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            extension: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.extension}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Description
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="description"
                        name="Description"
                        value={input.description}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            description: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.description}</div>
                    </div>
                  </div>

                   <div className="row mb-3">
                     
                    {state?.id &&<div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>}
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
